import { TextItemCombinedProps } from './types';

const usePresenter = (props: TextItemCombinedProps): TextItemCombinedProps => {
  return props;
};

export default usePresenter;
